import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Authentication = () => {
    const navigate = useNavigate();
    useEffect(() => {
       
        // If 'access_token' is present, navigate to invoices page
       // if (isTokenValid()) {
       //   navigate('/invoices');
       // }
      }, [navigate]);

    const redirectToZohoAuth = () => {
      const params = new URLSearchParams(window.location.search);
      //get the 'state' that should be passed. If not assume invoices
      const state = !params.get("state")?'invoices':params.get("state");

    // Replace with your Zoho OAuth2 authentication URL
    const callBackUri = process.env.REACT_APP_CALLBACK_URI;
    //const callBackUri = 'http://localhost:5001/auth/zoho/callback';
    //const clientId = '1000.FJGT9I0JHT78OR2MBTSCVZC353OW2W';
    const clientServerId = '1000.6JRP941I5GCEFD3ER2G34J1DVB1ILA';
    const authUrl = 'https://accounts.zoho.com/oauth/v2/auth?scope=ZohoBooks.fullaccess.all&client_id='+ clientServerId + '&state='+ state +'&response_type=code&redirect_uri='+callBackUri+'&access_type=offline';

    // Redirect the user to Zoho's authentication page
    window.location.href = authUrl;
  };
  const isTokenValid = () => {
    const accessToken = localStorage.getItem('access_token');
    const expiresIn = localStorage.getItem('expires_in');
    const expirationTime = localStorage.getItem('token_time');
  
    // Check if all necessary items are present in localStorage
    if (!accessToken || !expiresIn || !expirationTime) {
      return false; // Token or expiration data is missing
    }
  
    // Parse expiration time to milliseconds
    const expirationMilliseconds = parseInt(expirationTime) + parseInt(expiresIn) * 1000;
  
    // Check if the current time is before the token expiration time
    console.log(Date.now(), ' Should be smaller than ',expirationMilliseconds);
    return Date.now() < expirationMilliseconds;
    //return false;

  };
  return (
    <div>
      <h2>Zoho Authentication</h2>
      <p>Click the button below to authenticate with Zoho.</p>
      <button onClick={redirectToZohoAuth}>Authenticate with Zoho</button>
    </div>
  );
};

export default Authentication;
